import { Component, Inject } from '@angular/core';
import {
  MatSelectionList,
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';

import { ContentComponent } from '../content-component';

@Component({
  selector: 'content-browse-dialog',
  template: `<div class="modal__content">
  <div class="modal__header">
    <h3>Browse Content Components</h3>
  </div>
  <div class="modal__body">
    <mat-selection-list #componentList style="text-align: initial;">
      <mat-list-option *ngFor="let component of components" [value]="component">
        <h3 mat-line>{{component.name}}</h3>
        <p mat-line>{{component.description}}</p>
      </mat-list-option>
    </mat-selection-list>
    <p>Selected: {{componentList.selectedOptions.selected.length}}</p>
  </div>
  <div class="modal__footer">
    <button cuiButton color="primary" (click)="done(componentList)">Done</button>
    <button cuiButton color="negative" (click)="cancel()">Cancel</button>
  </div>
</div>`,
  styles: [``]
})
export class BrowseContentComponentsDialogComponent {
  private _components: ContentComponent[] = [];

  constructor(
    public dialogRef: MatDialogRef<BrowseContentComponentsDialogComponent, ContentComponent[]>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._components = data.components || [];
  }

  public get components(): ContentComponent[] { return this._components; }

  public done(list: MatSelectionList): void {
    this.dialogRef.close(list.selectedOptions.selected.map(item => item.value));
  }

  public cancel(): void {
    this.dialogRef.close([]);
  }

}
